import React from 'react';
import { useLocation } from 'react-router-dom';
import { FiMenu, FiBell, FiSearch, FiLogOut } from 'react-icons/fi';
import './Topbar.css';

/* ── Route → page title ─────────────────────────────────── */
const ROUTE_TITLES = {
  '/':            'Dashboard',
  '/mylearning':  'My Learning',
  '/tasks':       'Tasks',
  '/simulations': 'Simulations',
  '/interview':   'Interview Prep',
  '/mockexam':    'Mock Exams',
  '/profile':     'Profile',
  '/admin':       'Admin Panel',
};

function getTitle(pathname) {
  if (ROUTE_TITLES[pathname]) return ROUTE_TITLES[pathname];
  if (pathname.startsWith('/simulations/')) return 'Simulations';
  if (pathname.startsWith('/interview/'))   return 'Interview Prep';
  if (pathname.startsWith('/admin/'))       return 'Admin Panel';
  return 'TeraSkill LMS';
}

/* ── Topbar ─────────────────────────────────────────────── */
export default function Topbar({ userName, streakDays = 0, onMobileMenuToggle, onSignOut }) {
  const location = useLocation();
  const title    = getTitle(location.pathname);

  const initials = userName
    ? userName.split(' ').map(p => p[0]).join('').toUpperCase().slice(0, 2)
    : '?';

  return (
    <header className="topbar">
      {/* Left: Mobile hamburger + page title */}
      <div className="topbar-left">
        <button
          className="topbar-hamburger"
          onClick={onMobileMenuToggle}
          aria-label="Open navigation"
        >
          <FiMenu size={20} />
        </button>
        <h1 className="topbar-title">{title}</h1>
      </div>

      {/* Center: Search hint */}
      <div className="topbar-center">
        <button className="topbar-search" aria-label="Search">
          <FiSearch size={14} className="topbar-search-icon" />
          <span className="topbar-search-text">Search anything…</span>
          <kbd className="topbar-search-kbd">⌘K</kbd>
        </button>
      </div>

      {/* Right: Streak, notifications, avatar */}
      <div className="topbar-right">
        {/* Streak pill */}
        {streakDays > 0 && (
          <div className="topbar-streak" title={`${streakDays}-day learning streak`}>
            <span className="topbar-streak-flame">🔥</span>
            <span className="topbar-streak-count">{streakDays}</span>
          </div>
        )}

        {/* Notifications */}
        <button className="topbar-icon-btn" aria-label="Notifications" title="Notifications">
          <FiBell size={17} />
          <span className="topbar-notif-dot" aria-hidden="true" />
        </button>

        {/* User avatar */}
        <div className="topbar-avatar" title={userName}>
          {initials}
        </div>

        {/* Sign out */}
        <button
          className="topbar-signout-btn"
          onClick={onSignOut}
          title="Sign out"
          aria-label="Sign out"
        >
          <FiLogOut size={16} />
          <span className="topbar-signout-label">Sign out</span>
        </button>
      </div>
    </header>
  );
}
